module.exports = __webpack_public_path__ + "img/flex.cfb37596.png";